import * as React from 'react';
import { openForethoughtWidget } from 'utilities/forethought';
import { bugsnagNotify } from 'utilities/bugsnag';

export default class ErrorBoundary extends React.Component {
  state = {
    error: false
  };

  componentDidCatch(error, errorInfo) {
    bugsnagNotify(error);
    this.setState({ error: true });
  }

  render() {
    if (this.state.error) {
      return (
        <div>
          <h2>Oops! 😱</h2>
          <p>
            Something went wrong wrong in this general area and it's our fault. Please refresh the page and
            try again.
          </p>
          <p>
            If the problem persists, please reach out help@magoosh.com or{' '}
            <a onClick={openForethoughtWidget}>open a ticket</a>.
          </p>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}
